import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FilterFieldValue, FilterAgeRangeValue } from '../covance-filter.models';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterBaseType } from './covance-filter-base-type';
import { isNil } from 'lodash';

@Injectable()
export class CovanceFilterAgeRangeType extends CovanceFilterBaseType {
    private readonly separator = 'To';
    private readonly startRegExp = new RegExp(`^(\\d+?)[(](.*)[)]${this.separator}`);
    private readonly endRegExp = new RegExp(`${this.separator}(\\d+?)[(](.*)[)]$`);

    constructor(router: Router, route: ActivatedRoute) {
        super(router, route);
    }

    public serializeValue(filterValue: any): string {
        return filterValue;
    }

    public isMatch(fieldVal: FilterFieldValue, daysLived: number) {
        const filterValue = fieldVal.value as FilterAgeRangeValue;
        return filterValue.isInRange(daysLived);
    }

    public setValue(fieldVal: FilterFieldValue) {
        fieldVal.value = this.parseQueryString(fieldVal.queryParamValue);
    }

    public setQueryParamValue(fieldVal: FilterFieldValue) {
        if (!fieldVal.value) {
            fieldVal.queryParamValue = null;
            return;
        }
        const filterValue = fieldVal.value as FilterAgeRangeValue;
        const fromPart = !isNil(filterValue.ageValueStart) ? `${filterValue.ageValueStart}(${filterValue.ageUnitStart})` : '';
        const toPart = !isNil(filterValue.ageValueEnd) ? `${filterValue.ageValueEnd}(${filterValue.ageUnitEnd})` : '';
        fieldVal.queryParamValue = (!isNil(filterValue.ageValueStart) || !isNil(filterValue.ageValueEnd)) ?
            `${fromPart}${this.separator}${toPart}` : null;
    }

    private parseQueryString(value: string): FilterAgeRangeValue {
        if ( !value ) {
            return null;
        }
        
        const filter = new FilterAgeRangeValue(null, null, null, null);

        const matchStart = this.startRegExp.exec(value);
        const matchEnd = this.endRegExp.exec(value);

        filter.ageValueStart = matchStart && +matchStart[1];
        filter.ageUnitStart = matchStart && matchStart[2];
        filter.ageValueEnd = matchEnd && +matchEnd[1];
        filter.ageUnitEnd = matchEnd && matchEnd[2];

        return filter;
    }
}